import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { selectDefinedFieldTypes } from 'modules/catalogFieldTypes/selectors';
import { selectIsCatalogCollectionsFlagOn } from 'core/userContext';
import {
  skipFieldDefinition,
  skipFieldDefinitionAndUploadToCatalog,
  updateBulkCatalogItemsRequest,
  updateFieldsAndBulkCatalogItemsRequest,
} from '../actions';
import CatalogFormCSV from './CatalogFormCSV';

// type Props = {
//   isCatalogCollectionsFlagOn: boolean,
// };

export class CatalogFormCSVContainer extends React.Component {
  render() {
    return <CatalogFormCSV {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  component: CatalogFormCSV,
  isCatalogCollectionsFlagOn: selectIsCatalogCollectionsFlagOn(state),
  definedFields: selectDefinedFieldTypes(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      skipFieldDefinition,
      skipFieldDefinitionAndUploadToCatalog,
      updateBulkCatalogItemsRequest,
      updateFieldsAndBulkCatalogItemsRequest,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CatalogFormCSVContainer));
